import { useQuery } from '@apollo/client';

import { Feature } from '__generated__/GQL';
import { useCompanyBankAccounts } from 'common/hooks/useCompanyBankAccounts';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCurrentPricingPlan } from 'common/hooks/useCurrentPricingPlan';

import { TransfersHomePageDocument } from './graphql/transfersHomePage.gql';

const useTransfersHome = () => {
  const { companyProfileId } = useCompanyContext();
  const { isFeatureAvailable } = useCurrentPricingPlan();

  const hasAccessToBulkTransfers = isFeatureAvailable(Feature.BulkTransfers);

  const transferHomeQueryResult = useQuery(TransfersHomePageDocument, {
    skip: !companyProfileId || hasAccessToBulkTransfers,
    variables: {
      companyProfileId: companyProfileId as string,
    },
  });

  const {
    bankAccounts,
    error: bankAccountsQueryError,
    loading: loadingBankAccounts,
  } = useCompanyBankAccounts();

  if (transferHomeQueryResult.loading || loadingBankAccounts) {
    return { data: null, error: undefined, loading: true };
  }

  if (transferHomeQueryResult.error || bankAccountsQueryError) {
    return {
      data: null,
      error: transferHomeQueryResult.error || bankAccountsQueryError,
      loading: false,
    };
  }

  return {
    data: {
      bankAccounts: bankAccounts,
      hasAccessToBulkTransfers,
      higherPlanWithBulkTransfers:
        transferHomeQueryResult.data?.viewer.company.currentPlan
          .upgradablePlansWithFeatureAvailable[0],
    },
    error: undefined,
    loading: false,
  };
};

export default useTransfersHome;
